export enum CuoTireTypes {
  Personal = 1,
  Truck = 2,
  SpecialSolid = 3,
  Motorcycle = 4,
  SlowMoving = 5,
  SpecialPneumatic = 6
}

export const CuoTireTypeLabels = {
  [CuoTireTypes.Personal]: "Osobowe",
  [CuoTireTypes.Truck]: "Ciężarowe",
  [CuoTireTypes.SpecialSolid]: "Specjalne - pełne",
  [CuoTireTypes.SpecialPneumatic]: "Specjalne - pneumatyczne",
  [CuoTireTypes.Motorcycle]: "Motocyklowe",
  [CuoTireTypes.SlowMoving]: "Wolnobieżne"
};

export const CuoTireTypeOptions = [
  { key: CuoTireTypes.Personal, text: CuoTireTypeLabels[CuoTireTypes.Personal] },
  { key: CuoTireTypes.Truck, text: CuoTireTypeLabels[CuoTireTypes.Truck] },
  { key: CuoTireTypes.SpecialSolid, text: CuoTireTypeLabels[CuoTireTypes.SpecialSolid] },
  { key: CuoTireTypes.SpecialPneumatic, text: CuoTireTypeLabels[CuoTireTypes.SpecialPneumatic] },
  { key: CuoTireTypes.Motorcycle, text: CuoTireTypeLabels[CuoTireTypes.Motorcycle] },
  { key: CuoTireTypes.SlowMoving, text: CuoTireTypeLabels[CuoTireTypes.SlowMoving] }
];

export const getCuoTireTypeLabel = (tireType: CuoTireTypes | null): string => {
  return tireType !== null ? CuoTireTypeLabels[tireType] : "";
};
